module.exports = __webpack_public_path__ + "static/media/recover-final.1cdb71c9.svg";